import { Theme, useMediaQuery } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {
  CalendarMenuIcon,
  MyLearningMenuIcon,
  ProfileMenuIcon,
} from "components/common-icons/common-icons";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { SORT_ALPHABETICAL_ASCENDING } from "utils/constants";
import { CategoryCode } from "utils/types";
import { HeaderMenuIconSettings } from "../../utils/portalSettingsManager";
import { Notification } from "../notification/notification";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "&:hover": {
      boxShadow: "inset 0 -3px 0 0 #FFFFFF",
    },
    [theme.breakpoints.up("md")]: {
      width: "5rem",
    },
    [theme.breakpoints.down('lg')]: {
      width: "4.5rem",
    },
    [theme.breakpoints.down('md')]: {
      width: "3.8rem",
      marginLeft: ".4rem",
    },
    display: "flex",
    flexDirection: "column",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "2px",
  },
  icon: {
    fontSize: "1.2rem",
    paddingBottom: ".3rem",
  },
  label: {
    fontSize: "12px",
    paddingTop: ".2rem",
    whiteSpace: "nowrap",
  },
}));

const HeaderMenuIcons = (props: {
  headerMenuSettings: HeaderMenuIconSettings;
  notificationProps: any;
}) => {
  const { label, icon, root } = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleMyLearning = () => {
    dispatch({
      type: "search/setSearchFilters",
      payload: {
        sort: SORT_ALPHABETICAL_ASCENDING,
        code: CategoryCode.Required,
      },
    });
  };

  const hamburgermenu = useMediaQuery("(max-width: 700px)");

  return (
    <>
      {!hamburgermenu && !isEmpty(props.headerMenuSettings.myLearning) && (
        <NavLink
          aria-label={t(props.headerMenuSettings.myLearning.ariaKey)}
          to={props.headerMenuSettings.myLearning.url}
          key={1}
          onClick={handleMyLearning}
          className={root}
        >
          <MyLearningMenuIcon
            style={{
              color: props.headerMenuSettings.myLearning.color,
              backgroundColor: props.headerMenuSettings.myLearning.backGround,
            }}
            className={icon}
          />
          <span
            style={{
              color: props.headerMenuSettings.myLearning.textColor,
              backgroundColor: props.headerMenuSettings.myLearning.textBackColor,
            }}
            className={label}
          >
            {t(props.headerMenuSettings.myLearning.textKey)}
          </span>
        </NavLink>
      )}
      {!hamburgermenu && !isEmpty(props.headerMenuSettings.calendar) && (
        <NavLink
          aria-label={t(props.headerMenuSettings.calendar.ariaKey)}
          to={props.headerMenuSettings.calendar.url}
          key={2}
          className={root}
        >
          <CalendarMenuIcon
            style={{
              color: props.headerMenuSettings.calendar.color,
              backgroundColor: props.headerMenuSettings.calendar.backGround,
            }}
            className={icon}
          />
          <span
            style={{
              color: props.headerMenuSettings.calendar.textColor,
              backgroundColor: props.headerMenuSettings.calendar.textBackColor,
            }}
            className={label}
          >
            {t(props.headerMenuSettings.calendar.textKey)}
          </span>
        </NavLink>
      )}
      {!hamburgermenu && props.notificationProps.showNotification && (
        <Notification
          onClick={props.notificationProps.onClick}
          visible={props.notificationProps.notificationsOpen}
          setVisibility={props.notificationProps.toggleNotifications}
          notificationCount={props.notificationProps.notificationCount}
          isMobile={props.notificationProps.isMobile}
        />
      )}
      {!hamburgermenu && !isEmpty(props.headerMenuSettings.profile) && (
        <NavLink
          aria-label={t(props.headerMenuSettings.profile.ariaKey)}
          to={props.headerMenuSettings.profile.url}
          key={3}
          className={root}
        >
          <ProfileMenuIcon
            style={{
              color: props.headerMenuSettings.myLearning.color,
              backgroundColor: props.headerMenuSettings.profile.backGround,
            }}
            className={icon}
          />
          <span
            style={{
              color: props.headerMenuSettings.profile.textColor,
              backgroundColor: props.headerMenuSettings.profile.textBackColor,
            }}
            className={label}
          >
            {t(props.headerMenuSettings.profile.textKey)}
          </span>
        </NavLink>
      )}
    </>
  );
};

export default HeaderMenuIcons;